import { render, staticRenderFns } from "./riskDc.vue?vue&type=template&id=50c0ffd0&scoped=true"
import script from "./riskDc.vue?vue&type=script&lang=js"
export * from "./riskDc.vue?vue&type=script&lang=js"
import style0 from "./riskDc.vue?vue&type=style&index=0&id=50c0ffd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0ffd0",
  null
  
)

export default component.exports